import { render, staticRenderFns } from "./ManageLabPCRResultMaster.vue?vue&type=template&id=36e96f2e&scoped=true"
import script from "./ManageLabPCRResultMaster.vue?vue&type=script&lang=js"
export * from "./ManageLabPCRResultMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e96f2e",
  null
  
)

export default component.exports